module.exports = __webpack_public_path__ + "static/media/Electabuzz_gaussian2.5235dd3c.png";